<template>
    <ListeOffre/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import ListeOffre from "@/components/Offre/ListeOffre.vue";

    export default defineComponent({
      name: "ListeOffrePage",
      components: {
        
        ListeOffre,
      },
    });
  </script>